/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { ContactTracingPlaceDto } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getContactPatientContactPlaces = (options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<ContactTracingPlaceDto[]>({ url: `/api/contact-tracing/places`, method: 'GET', signal }, options);
};

export const getGetContactPatientContactPlacesQueryKey = () => {
  return [`/api/contact-tracing/places`] as const;
};

export const getGetContactPatientContactPlacesQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactPatientContactPlacesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactPatientContactPlaces>>> = ({ signal }) =>
    getContactPatientContactPlaces(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContactPatientContactPlacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactPatientContactPlaces>>
>;
export type GetContactPatientContactPlacesQueryError = ErrorType<unknown>;

export function useGetContactPatientContactPlaces<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof request>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactPatientContactPlaces<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>,
      'initialData'
    >;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactPatientContactPlaces<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetContactPatientContactPlaces<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetContactPatientContactPlacesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetContactPatientContactPlacesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactPatientContactPlacesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactPatientContactPlaces>>> = ({ signal }) =>
    getContactPatientContactPlaces(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContactPatientContactPlacesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactPatientContactPlaces>>
>;
export type GetContactPatientContactPlacesSuspenseQueryError = ErrorType<unknown>;

export function useGetContactPatientContactPlacesSuspense<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactPatientContactPlacesSuspense<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactPatientContactPlacesSuspense<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetContactPatientContactPlacesSuspense<
  TData = Awaited<ReturnType<typeof getContactPatientContactPlaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactPatientContactPlaces>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetContactPatientContactPlacesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createContactPatientContactPlace = (
  contactTracingPlaceDto: BodyType<ContactTracingPlaceDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/contact-tracing/places`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: contactTracingPlaceDto,
      signal,
    },
    options,
  );
};

export const getCreateContactPatientContactPlaceMutationOptions = <
  TData = Awaited<ReturnType<typeof createContactPatientContactPlace>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<ContactTracingPlaceDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createContactPatientContactPlace'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactPatientContactPlace>>,
    { data: BodyType<ContactTracingPlaceDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createContactPatientContactPlace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<ContactTracingPlaceDto> },
    TContext
  >;
};

export type CreateContactPatientContactPlaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactPatientContactPlace>>
>;
export type CreateContactPatientContactPlaceMutationBody = BodyType<ContactTracingPlaceDto>;
export type CreateContactPatientContactPlaceMutationError = ErrorType<unknown>;

export const useCreateContactPatientContactPlace = <
  TData = Awaited<ReturnType<typeof createContactPatientContactPlace>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<ContactTracingPlaceDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<ContactTracingPlaceDto> }, TContext> => {
  const mutationOptions = getCreateContactPatientContactPlaceMutationOptions(options);

  return useMutation(mutationOptions);
};
